import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/Layout/Footer.tsx");
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/Layout/Header.tsx");
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/PageLayouts/KontaktForm.tsx");
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/Text/Text.tsx");
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/Text/TextColors.tsx")